import $ from 'jquery';
import Form from './form';

$(function () {
    $('.form-generic').each((i, elem) => {
        new Form(elem);
    });
});



// WEBPACK FOOTER //
// ./assets/app/js/forms/generic.js